import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { StartChatConversationConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';

export class StartChatConversationNode extends NodeClass {
  constructor(
    id: string,
    position: { x: number; y: number },
    config: StartChatConversationConfig,
  ) {
    super(id, NodeType.StartChatConversation, position, config);
  }

  isEmptyConfig(): boolean {
    return !this.config['agentId'];
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
  }

  initNodeConfig() {
    (this.config as StartChatConversationConfig).agentId = '';
    (this.config as StartChatConversationConfig).allContacts = false;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];
    const config = this.config as StartChatConversationConfig;

    if (!config.agentId || config.agentId.trim() === '') {
      errors.push({
        nodeId: this.id,
        errorMessage: getValidationErrorMessage(ValidationError.NO_AGENT_SELECTED, {
          nodoType: 'Iniciar conversación de chat',
        }),
      });
    }

    return errors;
  }
}